<template>
	<div>
		<!-- <h4>Time Entries.</h4> -->


		<div>

			<vx-card title="Time Entries" class="mb-5 time-entries-card">
				<template slot="actions">
          <div>
            <div class="mt-2" style="display: inline-box">
            <vs-button size="small" v-if="!creatingFromEntry" :color="LerpColor(gradientStart, gradientEnd, 0)" class="mr-1 mb-1" @click="ClockInSubEntry('morningmeeting')">Morning Meeting</vs-button>
            <vs-button size="small" v-if="!creatingFromEntry" :color="LerpColor(gradientStart, gradientEnd, 1/7)" class="mr-1 mb-1" @click="ClockInSubEntry('meeting')">Meeting</vs-button>
            <vs-button size="small" v-if="!creatingFromEntry" :color="LerpColor(gradientStart, gradientEnd, 2/7)" class="mr-1 mb-1" @click="ClockInSubEntry('management')">Management</vs-button>
            <vs-button size="small" v-if="!creatingFromEntry" :color="LerpColor(gradientStart, gradientEnd, 3/7)" class="mr-1 mb-1" @click="ClockInSubEntry('marketing')">Marketing</vs-button>
            <vs-button size="small" v-if="!creatingFromEntry" :color="LerpColor(gradientStart, gradientEnd, 4/7)" class="mr-1 mb-1" @click="ClockInSubEntry('misctasks')">Misc Tasks</vs-button>
            <vs-button size="small" v-if="!creatingFromEntry" :color="LerpColor(gradientStart, gradientEnd, 5/7)" class="mr-1 mb-1" @click="ClockInSubEntry('breaktime')">Break Time</vs-button>
            
            <vs-button size="small" v-if="!creatingFromEntry" class="mr-1 mb-1" :color="LerpColor(gradientStart, gradientEnd, 6/7)" @click="BeginCreatingNewEntry()">New</vs-button>
            <vs-button size="small" v-if="!creatingFromEntry" class="mb-1" :color="LerpColor(gradientStart, gradientEnd, 7/7)" @click="BeginCreateFromEntry()">Duplicate</vs-button>
            <vs-button size="small" v-if="creatingFromEntry" class="" color="danger" @click="CancelCreateFromEntry()" icon="cancel">Cancel</vs-button>
          </div>
					<div class="flex timeEntriesFields float-right mt-1">
            
            
					
          </div>
          
          </div>

					</template>

			<vs-table
        search
        stripe
        max-items="50"
        pagination
        no-data-text="No Time Entries"
        :data="ParsedTimeEntryList()"
        v-model="selectedTimeEntry"
        @selected="HandleSelectedTimeEntry"
        class="teTable compact"
        :class="{creatingFromEntry: creatingFromEntry}"
        >
				<template slot="header">
          <div class="flex">
            <vs-switch v-model="hidePosted" class="mr-2" />
            Hide posted
          </div>
          <vs-alert v-if="creatingFromEntry" class="mr-5" style="color: white;">Select a time entry as a template</vs-alert>
				</template>
				<template slot="thead">
					<vs-th sort-key="EntryDateLabel">
					Time
					</vs-th>
					<vs-th v-if="isEveryone">
					Worker
					</vs-th>
					<vs-th class="min600" sort-key="ClientName">
					Client
					</vs-th>
					<vs-th class="min700" sort-key="CategoryName">
					Category
					</vs-th>
					<vs-th sort-key="ProjectName">
					Project
					</vs-th>
					<vs-th sort-key="TaskName">
					Task
					</vs-th>
          <vs-th class="min800" sort-key="Note">
					SOW
					</vs-th>
					<vs-th class="min800" sort-key="Note">
					Description
					</vs-th>
				</template>
				

				<template slot-scope="{data}">
					<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" :class="{'time-danger': EntryOverlapping(tr), 'time-posted': tr.Posted}">
           

            <vs-td :data="tr.EntryDateLabel">
							<vs-chip class="min900">
                <vs-chip color="danger" class="my-1 mr-1" v-if="EntryOverlapping(tr)">Overlap!</vs-chip>


								<vs-chip color="primary" class="my-1 mr-1"><h6 style="color:white">{{GetTimeDif(data[indextr].TimeIn, data[indextr].TimeOut)}}</h6> </vs-chip>
								<vs-chip color="primary" class="my-1 mr-1"> <h6 style="color:white">{{tr.EntryDateLabel}}</h6></vs-chip>
								<div class="ml-1" style="width: 115px;"> {{GetDateTimes(data[indextr].TimeIn, data[indextr].TimeOut)}}</div>
							</vs-chip>

							<div style="display: block; width: 70px;" v-if="windowWidth < 900" >
								<vs-chip color="primary" class="my-1 mr-1" style="width: 70px;">
									<h6 style="color:white">{{GetTimeDif(data[indextr].TimeIn, data[indextr].TimeOut)}}</h6> 
								</vs-chip>
								<vs-chip class="my-1 mr-1" style="width: 70px;"> 
									<h6 style="color:white">{{GetDateDay(data[indextr].TimeIn)}}</h6>
								</vs-chip>
							</div>
						</vs-td>

						<vs-td :data="tr.WorkerName" v-if="isEveryone" class="tableWorkerName">
							{{tr.WorkerName}}
						</vs-td>

						<vs-td :data="tr.ClientName" class="min600">
							{{tr.ClientName}}
						</vs-td>
						
				
						<vs-td :data="tr.CategoryName" class="tableTaskName min700">
							{{tr.CategoryName}}
						</vs-td>

						<vs-td>
							<div :data="tr.ProjectName" class="tdInfo tableTaskName">
								{{tr.ProjectName}}
							</div>
						</vs-td>

						<vs-td>
							<div :data="tr.Task" class="tdInfo tableTaskName">
								<span>{{ tr.TaskDisplay }}</span>
							</div>
						</vs-td>


            <vs-td :data="tr.SOWID" class="" @click.stop.native>
              <a v-if="tr.SOWID" href="#" @click.prevent.stop="OpenSOWFromEntry(tr)" class="text-primary cursor-pointer">
                <vx-tooltip v-if="GetSOWNumber(tr)" :text="GetSOWNumber(tr)" position="top">
                  <span>{{ tr.SOWName }}</span>
                </vx-tooltip>
                <span v-else>{{ tr.SOWName }}</span>
              </a>
              <span v-else>{{ tr.SOWName }}</span>
            </vs-td>

						<vs-td :data="tr.Note" class="min800 tableNote">
              {{tr.Note}}
            </vs-td>
					

					</vs-tr>
					
				</template>

			</vs-table>
			</vx-card>


      <SOWModal ref="sowModal" />
		</div>

	</div>
</template>


<script>

import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import 'vue-select/dist/vue-select.css'
import SOWModal from '@/components/SOWModal.vue'
const moment = require('moment')


export default{
  components:{
    flatPickr,
    'v-select': vSelect,
    SOWModal
  },
  data () {
    return {
      gradientStart: '#cc67f0',
      gradientEnd: '#7367f0',
      selectedTimeEntry 	: null,
      workerSwitch		: false,
      creatingFromEntry: false,
      hidePosted: true,
      page: 1,
      //selectedWorkerID	: -1

    }
  },
  watch: {
    hidePosted() {
      this.page = 1
    },
    workerID (val) {
      //this.selectedWorkerID = val
    },
    	userLoggedIn (loggedIn) {
      if (loggedIn) {
        this.OnLoggedIn()
      }
    },
    simulation (val) {
      this.$store.dispatch('ActionFetchTimeEntries')
			
    },
    taskList() {
      // this.CheckEntries()
    },
    timeEntryList() {
      // this.CheckEntries()
    },
    // isAdmin: function(val){
    // 	selectedWorkerID = this.workerID
    // }
  },
  computed:{
    simulation () {
      return this.$store.getters.GetSimulation
    },
    dbTimeFormatting () {
      return this.$store.getters.GetDBTimeFormatting
    },
    userLoggedIn () {
      return this.$store.getters.GetUserLoggedIn
    	},
    isEveryone () {
      return this.$store.getters.GetIsEveryone
    },
    isAdmin () {
      return this.$store.getters.GetIsAdmin
    },
    windowWidth () {
      return this.$store.state.windowWidth
    },
    timeEntryList () {
      const list = this.$store.getters.GetTimeEntryList
      //if(this.selectedWorkerID != -1){ //Selecting a certain worker
      //return list.filter(x => x.WorkerID == this.selectedWorkerID && x.TimeOut != null)
      //}else{ //Selecting all wrkers
      return list.filter(x => x.TimeOut != null)
      //	}
    },
    categoryList () {
      return this.$store.getters.GetCategoryList
    },
    rawCategoryList() {
	    return this.$store.getters.GetCategoryList
    },
    clientList () {
      return this.$store.getters.GetClientList
    },
    taskList () {
      return this.$store.getters.GetTaskList
    },
    projectList () {
      return this.$store.getters.GetProjectList
    },
    workerList () {
      return this.$store.getters.GetWorkerList
    },
    workerListAndAll () {
      const workers = []
      workers.push({'WorkerID': -1, 'WorkerName': 'All'})
      for (let i = 0; i < this.workerList.length; i++) {
        workers.push({ WorkerID: this.workerList[i].WorkerID, WorkerName: this.workerList[i].WorkerName })
      }
      return workers
    },
    activeUserInfo () {
      return this.$store.getters.AppActiveUser
    },
    workerID () {
      return this.$store.getters.GetWorkerID
    },
    mySOWLineItems() {
      return this.$store.getters.GetMySOWLineItems
    },
    sowLineItemTitleByID() {
      const map = {}
      const list = this.mySOWLineItems || []
      for (let i = 0; i < list.length; i++) {
        const li = list[i]
        if (li && li.SOWLineItemID != null) {
          map[li.SOWLineItemID] = li.Title
        }
      }
      return map
    },
    sowList() {
      return this.$store.getters.GetSOWList
    }
  },
  methods: {
    OpenSOWFromEntry (entry) {
      if (!entry || entry.SOWID == null) return
      const sow = this.sowList.find(x => x.SOWID === entry.SOWID)
      if (sow && this.$refs.sowModal) {
        this.$refs.sowModal.OpenForSOW(sow)
      }
    },
    GetSOWNumber(entry) {
      if (entry.SOWID == null) return ''
      const sow = this.sowList.find(x => x.SOWID === entry.SOWID)
      return sow ? (sow.SOWNumber || '') : ''
    },
    GetTaskDisplay(entry, jiraTaskName) {
      if (entry.SOWLineItemDescription && entry.SOWLineItemDescription !== '') {
        return entry.SOWLineItemDescription
      }
      if (entry.SOWLineItemID != null) {
        const title = this.sowLineItemTitleByID[entry.SOWLineItemID]
        if (title && title !== '') return title
      }
      if (jiraTaskName && jiraTaskName !== '-') return jiraTaskName
      return '-'
    },
    GetFormattedTime(time){
      if(time == null)
        return ""
      if(time.length == 7){
        return "0" + time;
      }else{
        return time
      }
    },
    CheckEntries() {
      if (this.timeEntryList.length == 0) {
        return
      }
      if (this.taskList.length == 0) {
        return
      }
      const list = this.timeEntryList
      for (let i = 0; i < list.length; i++) {
        const entry = list[i]
        const task =  this.GetTaskByID(entry.TaskJiraID)
        if (task != null) {
          let sow = task.SOW
          if (sow == null || sow == '') {
            sow =  'Undefined'
          }
          if (entry.CategoryName != sow) {
            const potentialCategory = this.rawCategoryList.find(x => x.CategoryName == sow && x.ClientID == task.ITATInfo.ClientID)
            
            let newCategoryId = 0
            if (potentialCategory != null) {
              newCategoryId = potentialCategory.CategoryID
            } 
            // else {
              
            //   this.$store.dispatch('ActionGetCategoryFromSOW', {
            //     ClientID: task.ITATInfo.ClientID,
            //     EpicName: sow,
            //   }).then(x => {
            //     newCategoryId = x[0].CategoryID
            //   })
            // }

            const startTime = moment.utc(entry.TimeIn, this.dbTimeFormatting).local().format('hh:mm A')
            const startDate = moment.utc(entry.TimeIn, this.dbTimeFormatting).local().format('Y-MM-DD')
            const endTime = moment.utc(entry.TimeOut, this.dbTimeFormatting).local().format('hh:mm A')
            const endDate = moment.utc(entry.TimeOut, this.dbTimeFormatting).local().format('Y-MM-DD')
            var timeIn = startDate + " " + this.GetFormattedTime(startTime)
            var timeOut = endTime == null ? null :  (endDate + " " + this.GetFormattedTime(endTime))

            var timeInUTC = moment(timeIn, "YYYY-MM-DD hh:mm A").utc().add(1, "hours").format()
            var timeOutUTC = moment(timeOut, "YYYY-MM-DD hh:mm A").utc().add(1, "hours").format()
            this.$store.dispatch("ActionPutTimeEntry", 
            {
              RecordID: entry.RecordID,
              CategoryID: newCategoryId,
              TimeIn: timeInUTC,
              TimeOut: timeOutUTC,
            })
          }
        }
      }
    },
    HexToRGB(h) {
      let r = 0, g = 0, b = 0;

      // 3 digits
      if (h.length == 4) {
        r = "0x" + h[1] + h[1];
        g = "0x" + h[2] + h[2];
        b = "0x" + h[3] + h[3];

      // 6 digits
      } else if (h.length == 7) {
        r = "0x" + h[1] + h[2];
        g = "0x" + h[3] + h[4];
        b = "0x" + h[5] + h[6];
      }
      return {
        r: parseInt(r, 16),
        g: parseInt(g, 16),
        b: parseInt(b, 16),
      }
    },
    RGBToHex(r,g,b) {
      r = r.toString(16).split('.')[0]
      g = g.toString(16).split('.')[0]
      b = b.toString(16).split('.')[0]

      if (r.length == 1)
        r = "0" + r;
      if (g.length == 1)
        g = "0" + g;
      if (b.length == 1)
        b = "0" + b;
      return "#" + r + g + b;
    },
    Lerp(a, b, t)
    {
        return a * (1 - t) + b * t;
    },
    LerpColor (a, b, amount) { 
      const rgb1 = this.HexToRGB(a)
      const rgb2 = this.HexToRGB(b)
      rgb1.r = this.Lerp(rgb1.r, rgb2.r, amount)
      rgb1.g = this.Lerp(rgb1.g, rgb2.g, amount)
      rgb1.b = this.Lerp(rgb1.b, rgb2.b, amount)

      return this.RGBToHex(rgb1.r, rgb1.g, rgb1.b)
    },
    ClockInSubEntry(template) {
      const currentDate = moment().format('Y-MM-DD')
      const currentTime = moment().format('hh:mm A')
      let clientId = (this.clientList.find(x => x.ClientName === 'ITAT - Internal') || {}).ClientID

      if (template == 'meeting') {
        this.$store.dispatch('ActionSetTimeEntryPrompt', {
          active: true,
          title: 'Clock In',
          taskName: null,
          jiraIssueID: null,
          clientName: 'ITAT - Internal',
          clientID: (this.clientList.find(x => x.ClientName === 'ITAT - Internal') || {}).ClientID,
          categoryID: this.categoryList.find(x => x.CategoryName === 'Meeting').CategoryID,
          clientCategory: 'Client Category',
          startTime: currentTime,
          startDate: currentDate,
          endTime: null,
          endDate: null,
          mileage: null,
          sowID: null,
          sowLineItemID: null,
          description: 'Meeting with ',
          error: 'Fields cannot be empty.',
          action: 'create' //create, clockin, finish
        })
      } else if(template == 'morningmeeting') {
        this.$store.dispatch('ActionSetTimeEntryPrompt', {
          active: true,
          title: 'Clock In',
          taskName: null,
          jiraIssueID: null,
          clientName: 'ITAT - Internal',
          clientID: (this.clientList.find(x => x.ClientName === 'ITAT - Internal') || {}).ClientID,
          categoryID: this.categoryList.find(x => x.CategoryName === 'Meeting').CategoryID,
          clientCategory: 'Client Category',
          startTime: '08:40 AM',
          startDate: currentDate,
          endTime: '09:00 AM',
          endDate: currentDate,
          mileage: null,
          sowID: null,
          sowLineItemID: null,
          description: 'Morning meeting',
          error: 'Fields cannot be empty.',
          action: 'create' //create, clockin, finish
        })
      } else if(template == 'management') {
        this.$store.dispatch('ActionSetTimeEntryPrompt', {
          active: true,
          title: 'Clock In',
          taskName: null,
          jiraIssueID: null,
          clientName: 'ITAT - Internal',
          clientID: (this.clientList.find(x => x.ClientName === 'ITAT - Internal') || {}).ClientID,
          categoryID: this.categoryList.find(x => x.CategoryName === 'Management').CategoryID,
          clientCategory: 'Client Category',
          startTime: currentTime,
          startDate: currentDate,
          endTime: null,
          endDate: null,
          mileage: null,
          sowID: null,
          sowLineItemID: null,
          description: 'Management',
          error: 'Fields cannot be empty.',
          action: 'create' //create, clockin, finish
        })
      } else if(template == 'marketing') {
        this.$store.dispatch('ActionSetTimeEntryPrompt', {
          active: true,
          title: 'Clock In',
          taskName: null,
          jiraIssueID: null,
          clientName: 'ITAT - Internal',
          clientID: (this.clientList.find(x => x.ClientName === 'ITAT - Internal') || {}).ClientID,
          categoryID: this.categoryList.find(x => x.CategoryName === 'Marketing').CategoryID,
          clientCategory: 'Client Category',
          startTime: currentTime,
          startDate: currentDate,
          endTime: null,
          endDate: null,
          mileage: null,
          sowID: null,
          sowLineItemID: null,
          description: 'Marketing',
          error: 'Fields cannot be empty.',
          action: 'create' //create, clockin, finish
        })
      } else if(template == 'misctasks') {
        
        this.$store.dispatch('ActionSetTimeEntryPrompt', {
          active: true,
          title: 'Clock In',
          taskName: null,
          jiraIssueID: null,
          clientName: 'ITAT - Internal',
          clientID: clientId,
          categoryID: this.categoryList.find(x => x.CategoryName === 'Misc. Tasks' && x.ClientID == clientId).CategoryID,
          clientCategory: 'Client Category',
          startTime: currentTime,
          startDate: currentDate,
          endTime: null,
          endDate: null,
          mileage: null,
          sowID: null,
          sowLineItemID: null,
          description: '',
          error: 'Fields cannot be empty.',
          action: 'create' //create, clockin, finish
        })
      } else if(template == 'breaktime') {
        this.$store.dispatch('ActionSetTimeEntryPrompt', {
          active: true,
          title: 'Clock In',
          taskName: '',
          jiraIssueID: null,
          clientName: 'ITAT - Internal',
          clientID: (this.clientList.find(x => x.ClientName === 'ITAT - Internal') || {}).ClientID,
          categoryID: this.categoryList.find(x => x.CategoryName === 'Break Time').CategoryID,
          // clientCategory: 'Client Category',
          task: null,
          startTime: currentTime,
          startDate: currentDate,
          endTime: null,
          endDate: null,
          mileage: null,
          sowID: null,
          sowLineItemID: null,
          description: 'Break time',
          error: 'Fields cannot be empty.',
          action: 'create' //create, clockin, finish
        })
      }
    },
    BeginCreateFromEntry() {
      this.creatingFromEntry = true
    },
    CancelCreateFromEntry() {
      this.creatingFromEntry = false
    },
    EntryOverlapping(tr){
      var sampleIn = moment(new Date(tr.TimeIn))
      var sampleOut = moment(new Date(tr.TimeOut))

      for(var i = 0; i < this.timeEntryList.length; i++){
		if (this.timeEntryList[i].RecordID != tr.RecordID) { // don't compare same entry
			var xIn = moment(new Date(this.timeEntryList[i].TimeIn))
			var xOut = moment(new Date(this.timeEntryList[i].TimeOut))
			if(sampleIn.isBetween(xIn, xOut) || sampleOut.isBetween(xIn,xOut)){
			return true
			}
			if (sampleIn.format('MM DD HH:mm') == xIn.format('MM DD HH:mm') && sampleOut.format('MM DD HH:mm') == xOut.format('MM DD HH:mm')) {
				return true
			}
		}
      }
	  
      return false
    },
    OnLoggedIn () {
      // this.$store.dispatch("ActionFetchProjects", 0)
      //this.$store.dispatch('ActionFetchTasks', [0, -1])
      // this.$store.dispatch("ActionFetchWorkerTasks")
    },
    ParsedTimeEntryList () {
      const list = this.timeEntryList
      const newList = []
      const putPromises = []
      for (let i = 0; i < list.length; i++) {
        const entry = list[i]
        const mockEntry = {}
        let taskName = '-'
        let projectName = '-'
        const task = this.GetTaskByID(entry.JiraIssueID)
        if (task != null && task.fields != null) {
          taskName = task.fullName
          projectName = task.fields.project.name
        }
        mockEntry.RecordID = entry.RecordID
        mockEntry.EntryDate = entry.EntryDate
        mockEntry.Note = entry.Note
        mockEntry.SortBy = entry.SortBy
        mockEntry.WorkerID = entry.WorkerID
        // mockEntry.TaskID = entry.TaskID
        mockEntry.TimeIn = entry.TimeIn
        mockEntry.TimeOut = entry.TimeOut
        mockEntry.ProjectID = entry.ProjectID
        mockEntry.ClientID = entry.ClientID
        mockEntry.WorkerName = entry.WorkerName
        mockEntry.ClientName = (this.GetClientByID(entry.ClientID) || {}).ClientName || '-'
        mockEntry.CategoryName = this.GetCategoryByID(entry.CategoryID).CategoryName
        mockEntry.CategoryID = entry.CategoryID
        mockEntry.ProjectName = projectName
        mockEntry.JiraIssueID = entry.JiraIssueID
        mockEntry.Task = taskName
        mockEntry.EntryDateLabel = this.GetDateDay(entry.TimeIn)
        mockEntry.Posted = entry.Posted
        mockEntry.SOWID = entry.SOWID
        mockEntry.SOWLineItemID = entry.SOWLineItemID
        mockEntry.SOWName = entry.SOWName
        mockEntry.SOWLineItemDescription = entry.SOWLineItemDescription
        mockEntry.TaskDisplay = this.GetTaskDisplay(entry, taskName)
        newList.push(mockEntry)
      }
      if (this.hidePosted) {
        return newList.filter(x => x.Posted == false)
      } else {
        return newList
      }
    },
    // OnChangedWorker(){
    // 	if(this.selectedWorkerID == null){
    // 		this.selectedWorkerID = -1;
    // 	}
    // },
    WorkerNameFromID (id) {
      if (this.workerList == null) return ''
      const worker = this.workerList.find(x => x.WorkerID == id)
      if (worker == null) return ''
      return worker.WorkerName
    },
    HandleSelectedTimeEntry (timeEntry) {
      if (this.creatingFromEntry) {
        this.creatingFromEntry = false
        this.$store.dispatch('ActionSetTimeEntryPrompt', {
            active: true,
            title: 'Create New Time Entry',
            clientID: timeEntry.ClientID,
            categoryID: timeEntry.CategoryID,
            jiraIssueID: timeEntry.JiraIssueID,
            projectID: timeEntry.ProjectID,
            startTime: moment.utc(timeEntry.TimeIn, this.dbTimeFormatting).local().format('hh:mm A'),
            startDate: moment.utc(timeEntry.TimeIn, this.dbTimeFormatting).local().format('Y-MM-DD'),
            endTime: moment.utc(timeEntry.TimeOut, this.dbTimeFormatting).local().format('hh:mm A'),
            endDate: moment.utc(timeEntry.TimeOut, this.dbTimeFormatting).local().format('Y-MM-DD'),
            description: timeEntry.Note,
            mileage: timeEntry.Mileage,
            sowID: timeEntry.SOWID,
            sowLineItemID: timeEntry.SOWLineItemID,
            jiraLogID: timeEntry.JiraLogID,
            action: 'create'
          })
      } else {

        // Responsiveness
        this.$store.dispatch('ActionSetTimeEntryPrompt', {
          active: true,
          title: 'Edit Existing Time Entry',
          recordID: timeEntry.RecordID,
          clientID: timeEntry.ClientID,
          categoryID: timeEntry.CategoryID,
          jiraIssueID: timeEntry.JiraIssueID,
          projectID: timeEntry.ProjectID,
          startTime: moment.utc(timeEntry.TimeIn, this.dbTimeFormatting).local().format('hh:mm A'),
          startDate: moment.utc(timeEntry.TimeIn, this.dbTimeFormatting).local().format('Y-MM-DD'),
          endTime: moment.utc(timeEntry.TimeOut, this.dbTimeFormatting).local().format('hh:mm A'),
          endDate: moment.utc(timeEntry.TimeOut, this.dbTimeFormatting).local().format('Y-MM-DD'),
          description: timeEntry.Note,
          mileage: timeEntry.Mileage,
          sowID: timeEntry.SOWID,
          sowLineItemID: timeEntry.SOWLineItemID,
          jiraLogID: timeEntry.JiraLogID,
          Posted: timeEntry.Posted,
          action: 'edit' //create, edit, finish
        })

        this.$store.dispatch('ActionFetchTimeEntry', timeEntry.RecordID.toString()).then(response => {
          const data = response.data
          
          this.$store.dispatch('ActionSetTimeEntryPrompt', {
            active: true,
            title: 'Edit Existing Time Entry',
            recordID:data.RecordID,
            clientID: data.ClientID,
            categoryID: data.CategoryID,
            jiraIssueID: data.JiraIssueID,
            projectID: data.ProjectID,
            startTime: moment.utc(data.TimeIn, this.dbTimeFormatting).local().format('hh:mm A'),
            startDate: moment.utc(data.TimeIn, this.dbTimeFormatting).local().format('Y-MM-DD'),
            endTime: moment.utc(data.TimeOut, this.dbTimeFormatting).local().format('hh:mm A'),
            endDate: moment.utc(data.TimeOut, this.dbTimeFormatting).local().format('Y-MM-DD'),
            description: data.Note,
            mileage: data.Mileage,
            sowID: data.SOWID,
            sowLineItemID: data.SOWLineItemID,
            jiraLogID: data.JiraLogID,
            Posted: timeEntry.Posted,
            action: 'edit' //create, edit, finish
          })
        })
      }
    

    },
    GetClientByID (clientID) {
      let client = this.clientList.find(x => x.ClientID == clientID)
      if (client == null) client = {ITATInfo: {ClientName:'None'}}

      return client
    },
    GetProjectByID (projectID) {
			
      let project = this.projectList.find(x => x.ITATInfo.ProjectID == projectID)
      if (project == null) {
        project = {
          JiraInfo:{
            name: '-'
          }
        }
      }
      return project
    },
    GetProjectByCategoryID (categoryID) {
      let project = this.projectList.find(x => x.CategoryID == categoryID)
      if (project == null) {
        project = {ProjectName:'None'}
      } else if (project.ProjectName == '' || project.ProjectName == null) {
        project = {ProjectName:'None'}
      }
			
      return project
    },
    GetTaskByID (jiraIssueId) {
      let task = this.taskList.find(x => x.id == jiraIssueId)
      if (task == null) {
        task = {Task: 'None'}
      }
     
      return task
    },
    GetCategoryByID (categoryID) {
      let category = this.categoryList.find(x => x.CategoryID == categoryID)
      if (category == null) category = {CategoryName : 'None'}

      return category
    },
    BeginCreatingNewEntry () {
      const currentTime = moment().format('hh:mm A')
      const currentDate = moment().format('Y-MM-DD')
      this.$store.dispatch('ActionSetTimeEntryPrompt', {
        active: true,
        title: 'Create New Time Entry',
        taskName: '',
        clientID: null,
        jiraIssueID: null,
        projectID: null,
        categoryID: null,
        startTime: currentTime,
        endTime: null,
        startDate: currentDate,
        endDate: null,
        description: '',
        mileage: 0,
        sowID: null,
        sowLineItemID: null,
        error: 'Fields cannot be empty.',
        action: 'create' //create, edit, finish
      })
    },
    GetDateDay (s) {
      return moment(moment.utc(s, this.dbTimeFormatting).toDate()).format('M/DD')
    },
    GetDateTimes (s, e) {
      return `${moment(moment.utc(s, this.dbTimeFormatting).toDate()).format('h:mm A')  } - ${   moment(moment.utc(e, this.dbTimeFormatting).toDate()).format('h:mm A')}`
    },
    GetTimeDif (s, e) {
			

      const ms = moment(e, this.dbTimeFormatting).diff(moment(s, this.dbTimeFormatting))
      const d = moment.duration(ms)
      const p = Math.floor(d.asHours()) + moment.utc(ms).format(':mm')

      return p

    }
  },
  mounted () {
    // this.selectedWorkerID = this.workerID
    	 if (this.userLoggedIn) {
			 this.OnLoggedIn()
    }	
	  }
	
}

</script>

<style lang="scss" scoped>
.time-entries-card .vx-card__body {
  padding-top: 0;
}
</style>
<style lang="css">
.time-danger{
  background: #ff000021 !important;
}

.time-posted {
  opacity: .5 !important;
  background: #99999999 !important;

}

.vs-con-table.stripe .tr-values.time-posted:nth-child(2n) {
  background: #99999999 !important;

}

.vs-con-table.stripe .tr-values:nth-child(2n).time-danger{
  background: #ff000021 !important;
}

.text-loader {
    width: 200px;
    height: 12px;
    background: #ffffff87;
    border-radius: 5px;
}
.pulsing {
  animation-duration: 1s;
  animation-name: pulsing;
  animation-iteration-count: infinite;
}

.teTable {
  transition: all .3s ease;
  padding: 0px;
  background: #ffffff00
}

.creatingFromEntry {
  padding: 10px;
  background: #ffffff87;
  animation-duration: 1s;
  animation-name: pulsing2;
  animation-iteration-count: infinite;
}

.text-loader:nth-child(1) {
    margin-bottom: 8px;
}
.text-loader:nth-child(2) {
    width: 120px;
    animation-delay: 200ms
}
@keyframes pulsing {
  from {
    background: #ffffff87;
  }
  50% {
    background: #ffffff55;
  }

  to {
    background: #ffffff87;
  }
}
@keyframes pulsing2 {
  from {
    background: #ffffff22;
  }
  50% {
    background: #ffffff11;
  }

  to {
    background: #ffffff22;
  }
}

</style>